module.exports = __webpack_public_path__ + "static/media/Charles isbell.de6e3266.jpg";